<!--<button (click)="clearSelection()">Clear Selection</button>-->
<!-- AG Grid Angular Component -->
<!--<app-filters></app-filters>-->
<ag-grid-angular
        style="width: 100%; height: 600px;"
        class="ag-theme-alpine"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowData]="rowData$ | async"
        [rowSelection]="'multiple'"
        [animateRows]="true"
        [enableRtl]="true"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (cellClicked)="onCellClicked($event)"
></ag-grid-angular>
